import { render, staticRenderFns } from "./garden11.vue?vue&type=template&id=063cfbbe&scoped=true"
import script from "./garden11.vue?vue&type=script&lang=js"
export * from "./garden11.vue?vue&type=script&lang=js"
import style0 from "./garden11.vue?vue&type=style&index=0&id=063cfbbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063cfbbe",
  null
  
)

export default component.exports